var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99988 5C4.44759 5 3.99988 5.44772 3.99988 6V20C3.99988 20.5523 4.44759 21 4.99988 21H18.9999C19.5522 21 19.9999 20.5523 19.9999 20V6C19.9999 5.44772 19.5522 5 18.9999 5H4.99988ZM1.99988 6C1.99988 4.34315 3.34302 3 4.99988 3H18.9999C20.6567 3 21.9999 4.34315 21.9999 6V20C21.9999 21.6569 20.6567 23 18.9999 23H4.99988C3.34302 23 1.99988 21.6569 1.99988 20V6Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1C16.5523 1 17 1.44772 17 2V6C17 6.55228 16.5523 7 16 7C15.4477 7 15 6.55228 15 6V2C15 1.44772 15.4477 1 16 1Z",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00012 0.999939C8.55241 0.999939 9.00012 1.44765 9.00012 1.99994V5.99994C9.00012 6.55222 8.55241 6.99994 8.00012 6.99994C7.44784 6.99994 7.00012 6.55222 7.00012 5.99994V1.99994C7.00012 1.44765 7.44784 0.999939 8.00012 0.999939Z",
    fill: "#888888"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99988 10C1.99988 9.44772 2.44759 9 2.99988 9H20.9999C21.5522 9 21.9999 9.44772 21.9999 10C21.9999 10.5523 21.5522 11 20.9999 11H2.99988C2.44759 11 1.99988 10.5523 1.99988 10Z",
    fill: "#888888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarOutline);
export default __webpack_public_path__ + "static/media/calendar-outline.e67bd63d.svg";
export { ForwardRef as ReactComponent };